module.exports = __webpack_public_path__ + "img/refresh.ec741acf.svg";